var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"notification",class:{'notification--unread' : _vm.unreadNotificationCount},on:{"click":_vm.showNotificationsSidebar}},[_c('AlertSVG')],1)}
var staticRenderFns = []

export { render, staticRenderFns }